import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userCardAPI } from '../api/userCardAPI';
import { ICreateCard } from '../types/Create';
import { custonSooner } from '../../../components/CustopmSooner';

export const useCreateCard = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (card: ICreateCard) => await userCardAPI.create(card),
    onSuccess: res => {
      if (res.data.success) {
        queryClient.invalidateQueries({ queryKey: ['user-card'] });
      } else {
        custonSooner.error(res.data.message);
      }
    },
    onError: (error: any) => {
      const message = error?.response?.data?.message || 'Что то пошло не так';
      custonSooner.error(message);
    },
  });
  return {
    createCard: mutateAsync,
    isPending,
  };
};
